"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemoryStorage = exports.ExpiryLiveStorage = exports.LiveStorage = void 0;
/******************************************************************
 * Copyright @ 2023 广州牛师帮文化科技有限公司. All rights reserverd.
 * @file   src\LiveStorage\index.ts
 * @author 朱剑豪
 * @date   2023/01/18 18:34
 * @desc   提供一系列可感知变化的storage
 ******************************************************************/
var event_1 = require("../event");
var LiveStorage = /** @class */ (function (_super) {
    __extends(LiveStorage, _super);
    function LiveStorage(storage) {
        var _this = _super.call(this) || this;
        _this._storage = storage;
        return _this;
    }
    LiveStorage.get = function (type) {
        if (type === void 0) { type = 'local'; }
        switch (type) {
            case 'session':
                this._session = this._session || new LiveStorage(sessionStorage);
                return this._session;
            case 'local':
                this._local = this._local || new LiveStorage(localStorage);
                return this._local;
            case 'expiry_local':
                this._expiryLocal = this._expiryLocal || new ExpiryLiveStorage(localStorage);
                return this._expiryLocal;
            case 'expiry_session':
                this._expirySession = this._expirySession || new ExpiryLiveStorage(sessionStorage);
                return this._expirySession;
            case 'memory':
                this._memory = this._memory || new LiveStorage(new MemoryStorage());
                return this._memory;
            case 'expiry_memory':
                this._expiryMemory = this._expiryMemory || new ExpiryLiveStorage(new MemoryStorage());
                return this._expiryMemory;
        }
    };
    Object.defineProperty(LiveStorage.prototype, "length", {
        get: function () { return this._storage.length; },
        enumerable: false,
        configurable: true
    });
    ;
    LiveStorage.prototype.clear = function () {
        var _this = this;
        var length = this.length;
        var keys = [];
        for (var i = 0; i < length; ++i) {
            var key = this.key(i);
            if (!key) {
                continue;
            }
            keys.push(key);
        }
        keys.forEach(function (key) { return _this.removeItem(key); });
        return this._storage.clear();
    };
    LiveStorage.prototype.getItem = function (key) {
        return this._storage.getItem(key);
    };
    LiveStorage.prototype.key = function (index) {
        return this._storage.key(index);
    };
    LiveStorage.prototype.removeItem = function (key) {
        if (this.getItem(key) === null) {
            return;
        }
        var ret = this._storage.removeItem(key);
        this.emit(key, null);
        return ret;
    };
    LiveStorage.prototype.setItem = function (key, value, expireTime) {
        if (expireTime === void 0) { expireTime = 0; }
        if (this.getItem(key) === value) {
            return;
        }
        var ret = this._storage.setItem(key, value);
        this.emit(key, { value: value, expiry: 0 });
        return ret;
    };
    LiveStorage.prototype.observe = function (key, callback) {
        var ret = this.subscribe(key, callback);
        var value = this.getItem(key);
        callback(value ? { value: value, expiry: 0 } : null);
        return ret;
    };
    LiveStorage.prototype.subscribe = function (key, callback) {
        return this.on(key, callback);
    };
    return LiveStorage;
}(event_1.Emitter));
exports.LiveStorage = LiveStorage;
var ExpiryLiveStorage = /** @class */ (function (_super) {
    __extends(ExpiryLiveStorage, _super);
    function ExpiryLiveStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpiryLiveStorage.prototype.parse = function (raw) {
        if (!raw) {
            return null;
        }
        try {
            var ret = JSON.parse(raw);
            if (typeof ret.expiry !== 'number') {
                return null;
            }
            if (ret.expiry > 0 && Date.now() > ret.expiry) {
                return null;
            }
            return ret;
        }
        catch (e) {
            return null;
        }
    };
    ExpiryLiveStorage.prototype.removeExpiryItem = function (key) {
        this._storage.removeItem(key);
        this.emit(key, null);
    };
    ExpiryLiveStorage.prototype.setExpiryItem = function (key, item) {
        var raw = JSON.stringify(item);
        this._storage.setItem(key, raw);
        this.emit(key, item);
    };
    ExpiryLiveStorage.prototype.getExpiryItem = function (key) {
        var raw = _super.prototype.getItem.call(this, key);
        return this.parse(raw);
    };
    ExpiryLiveStorage.prototype.getItem = function (key) {
        var _a;
        return ((_a = this.getExpiryItem(key)) === null || _a === void 0 ? void 0 : _a.value) || null;
    };
    ExpiryLiveStorage.prototype.setItem = function (key, value, expireTime) {
        if (expireTime === void 0) { expireTime = 0; }
        this.setExpiryItem(key, {
            expiry: expireTime > 0 ? (Date.now() + expireTime) : 0,
            value: value
        });
    };
    ExpiryLiveStorage.prototype.observe = function (key, callback) {
        var ret = this.subscribe(key, callback);
        var item = this.getExpiryItem(key);
        callback(item);
        return ret;
    };
    ExpiryLiveStorage.prototype.subscribe = function (key, callback) {
        return this.on(key, callback);
    };
    return ExpiryLiveStorage;
}(LiveStorage));
exports.ExpiryLiveStorage = ExpiryLiveStorage;
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this._pool = {};
        this._length = 0;
    }
    Object.defineProperty(MemoryStorage.prototype, "length", {
        get: function () { return this._length; },
        enumerable: false,
        configurable: true
    });
    MemoryStorage.prototype.clear = function () {
        this._pool = {};
        this._length = 0;
    };
    MemoryStorage.prototype.getItem = function (key) {
        return this._pool[key] || null;
    };
    MemoryStorage.prototype.key = function (index) {
        return Object.keys(this._pool)[index] || null;
    };
    MemoryStorage.prototype.removeItem = function (key) {
        if (typeof this._pool[key] === 'string') {
            this._length--;
        }
        delete this._pool[key];
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        if (typeof this._pool[key] !== 'string') {
            this._length++;
        }
        this._pool[key] = value;
    };
    MemoryStorage.instance = function () {
        if (!this._inst) {
            this._inst = new MemoryStorage;
        }
        return this._inst;
    };
    return MemoryStorage;
}());
exports.MemoryStorage = MemoryStorage;
//# sourceMappingURL=index.js.map